export const ACTIVATION_STATUS_ARCHIVED = 'archived';
export const ACTIVATION_STATUS_IN_PROGRESS = 'in_progress';
